// 判断是否是最后一条数据，原来判断要不要重新请求的时候翻页
export const RANKSTUDENTLIMITED = 5 // 学生排名
export const RANKTEACHERLIMITED = 2 // 老师排名
/**
 参赛组别
 */
export const LEVELS = [
    {ID:1,Name:"专科组"},
    {ID:2,Name:"本科生组"},
    {ID:3,Name:"研究生组"},
]
/**
 性别
 */
export const SEXS = [
    {ID:1,Name:"男"},
    {ID:2,Name:"女"}
]
/**
 学生类型
 */
export const STUDENTTYPE = [
    {ID:1,Name:"专科生"},
    {ID:2,Name:"本科生"},
    {ID:3,Name:"硕士研究生"},
    {ID:4,Name:"博士研究生"},
]
/**
 学生年级
 */
export const GRADE = [
    {ID:1,Name:"一年级"},
    {ID:2,Name:"二年级"},
    {ID:3,Name:"三年级"},
    {ID:4,Name:"四年级"},
    {ID:5,Name:"五年级"},
    {ID:6,Name:"六年级"},
    {ID:7,Name:"七年级"},
]
// 初赛
export const PREWORKSTATUS = [
    {ID:1,Name:"未设置"},
    {ID:2,Name:"初赛一等奖 (进入复赛)"},
    {ID:3,Name:"初赛淘汰"},
    {ID:4,Name:"初赛二等奖"},

]
/**
 复赛状态
 */
export const FinalWORKSTATUS = [
    {ID:0,Name:"未设置状态"},
    {ID:1,Name:"决赛一等奖"},
    {ID:2,Name:"决赛二等奖"},
    {ID:3,Name:"决赛三等奖"},
]
/**
 原始状态，废弃了
 */
export const WORKSTATUS = [
    {ID:1,Name:"未设置状态"},
    {ID:2,Name:"晋级"},
    {ID:3,Name:"淘汰"},
]
/**
 晋升类型
 */
export const DOCUMENTTYPES = [
    {ID:"1",Name:"身份证"},
    {ID:"2",Name:"护照"},
]

// arr,id,找到arr中ID为id的Name
export function getName(arr,id){
    if(!Array.isArray(arr)){
        return ""
    }
    const ele = arr.find(item=>item.ID===id)
    if(ele){
        return ele.Name
    }else{
        return ""
    }
}

// 获取年份，获取从2025年到现在的年份
export function getYears(num){
    if(!num){
        num = 5
    }
    const currentYear = new Date().getFullYear()
    const arr = []
    for(let i=2025;i<=currentYear;i++){
        arr.push({ID:i,Name:i+"年"})
    }
    return arr
}
// 获取年份，从现在往前的年份
export function getYearsList(num){
    if(!num){
        num = 5
    }
    const currentYear = new Date().getFullYear()
    const arr = []
    for(let i=currentYear;i>currentYear-num;--i){
        arr.push({ID:i,Name:i+"年"})
    }
    return arr
}
// 办学层次
export const SCHOOLLEVELS = [
    {ID:"专科",Name:"专科"},
    {ID:"本科",Name:"本科"},
]
// 用户角色
export const USERROLE = [
    {ID:1,Name:"超级管理员",des:"拥有最高权限，包含删除、修改配置等权限"},
    {ID:3,Name:"普通管理员",des:"不可删除、修改配置信息"},
    {ID:2,Name:"评审专家",des:"专家评审登录"},
]
// 职称
export const JOBLEVEL = [
    {ID:"教授",Name:"教授"},
    {ID:"副教授",Name:"副教授"},
    {ID:"研究员",Name:"研究员"},
    {ID:"副研究员",Name:"副研究员"},
    {ID:"高级工程师",Name:"高级工程师"},
]
// 教师职称
export const TITLELEVEL = [
    {ID:"助教",Name:"助教"},
    {ID:"讲师",Name:"讲师"},
    {ID:"副教授",Name:"副教授"},
    {ID:"副高",Name:"副高"},
    {ID:"正高",Name:"正高"},
    {ID:"教授",Name:"教授"},
]


